import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSetting,
  BackendMutationUpdateCustomerSettingsArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateWordsToAvoid($customerId: ID!, $wordsToAvoid: [String!]) {
    updateCustomerSettings(customerId: $customerId, wordsToAvoid: $wordsToAvoid) {
      wordsToAvoid
    }
  }
`;

type Variables = Pick<BackendMutationUpdateCustomerSettingsArgs, 'customerId' | 'wordsToAvoid'>;
type Result = Pick<BackendCustomerSetting, 'wordsToAvoid'>;

export const updateWordsToAvoid = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data)?.wordsToAvoid ?? [];
};
